export default function testimonialSlider() {
	let container,
		slides,
		slidesCount,
		maxHeight = 0,
		timeout,
		controls,
		leftBtn,
		touchPos = 0,
		dragging = false,
		rightBtn;

	container = document.querySelector('.testimonialsSlider-wrapper');

	if ( ! container ) {
		return;
	}



	function init( resize ) {

		maxHeight = 0;
		slides = [ ... container.getElementsByClassName('testimonialsSlider-item') ];
		slidesCount = slides.length - 1;
		controls = container.querySelector('.testimonialsSlider-controls');
		leftBtn =  controls.querySelector('.testimonialsSlider-controls-left');
		rightBtn =  controls.querySelector('.testimonialsSlider-controls-right');
		rightBtn.onclick = right;
		leftBtn.onclick = left;

		removeStylesAndEvents();


		if (!window.matchMedia("(min-width: 800px)").matches) {

			return;
		}
		
		
		for (let i = 0; i <= slidesCount; i++) {
			maxHeight = slides[i].clientHeight > maxHeight ? slides[i].clientHeight : maxHeight;
		}


		for (let i = 0; i <= slidesCount; i++) {
			slides[i].style.height =  maxHeight + 'px';
			if(i < 3) {
				slides[i].style.transform = `translate3d(0, ${i*2}rem, ${-i}rem)`;
				slides[i].style.zIndex = slides.length - i;
			}else{
				slides[i].style.transform = `translate3d(0, ${2}rem, ${-2}rem)`;
				slides[i].style.zIndex = slides.length - i;
			}
			slides[i].addEventListener('mousedown', startDrag);
			slides[i].addEventListener('touchstart', startDrag);
			slides[i].addEventListener('mousemove', drag);
			slides[i].addEventListener('touchmove', drag);
			slides[i].addEventListener('mouseup', stopDrag);
			slides[i].addEventListener('touchend', stopDrag);
		}

		container.style.height = maxHeight + rem(5) + 'px';

		controls.style.top = maxHeight / 2 + 'px';

	}

	function removeStylesAndEvents() {

		for (let i = 0; i <= slidesCount; i++) {
			slides[i].removeAttribute("style");
			slides[i].removeEventListener('mousedown', startDrag);
			slides[i].removeEventListener('touchstart', startDrag);
			slides[i].removeEventListener('mousemove', drag);
			slides[i].removeEventListener('touchmove', drag);
			slides[i].removeEventListener('mouseup', stopDrag);
			slides[i].removeEventListener('touchend', stopDrag);

		}
		container.removeAttribute("style");


	}



	function left (dragLeft) {

		if(!dragLeft){
			slides[0].style.transform = `translate3d(110%, 0, 0)`;
		}else {
			slides[0].style.transform = `translate3d(-110%, 0, 0)`;
		}
		slides.push( slides.shift() );
		clearTimeout(timeout);
		timeout = setTimeout(rebuild, 500);
		
	}


	function right () {
		slides[slidesCount].style.visibility = 'visible';
		slides[slidesCount].style.opacity = 1;
		slides[slidesCount].style.transform = `translate3d(calc(-110% - ${3}rem), ${3*2}rem, ${-3}rem)`;
		slides.unshift( slides.pop() );

		clearTimeout(timeout);
		timeout = setTimeout(rebuild, 500);
	}


	function rebuild() {

		for (let i = 0; i <= slidesCount; i++) {
			
			if(i < 3) {
				slides[i].style.opacity = 1;
				slides[i].style.visibility = 'visible';
				slides[i].style.transform = `translate3d(0, ${i*2}rem, ${-i}rem)`;
			}else{
				slides[i].style.opacity = 0;
				slides[i].style.visibility = 'hidden';
				slides[i].style.transform = `translate3d(0, ${2*2}rem, ${-2}rem)`;
			}
			slides[i].style.zIndex = slides.length - i;
		}
		
	}

	function startDrag(e) {
		if(e.type =="touchstart") {
			touchPos = e.touches[0].clientX;
		}else {
			touchPos = e.clientX;
		}
		dragging = true;
		slides[0].style.transition='none';
	}

	function drag(e) {
		
		if( dragging ) {
			let delta = 0;

			if(e.type =="touchmove") {
				delta = e.touches[0].clientX - touchPos;
			}else{
				delta = e.clientX-touchPos;
				
			}
			slides[0].style.transform = `translate3d(${delta}px, 0, 0)`;
		}
	}

	function stopDrag(e) {
		
		if( dragging ) {

			let delta = 0;

			if(e.type =="touchend") {

				delta = e.changedTouches[0].clientX - touchPos;
			}else{
				delta = e.clientX-touchPos;
			}
			slides[0].style.transition='';

			if(delta > 0) {
				left();
			}else {
				left(1);
			}

		}

		dragging = false;
	}


	function rem(rem) {    
    	return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
	}


	window.addEventListener("resize", init);

	if (!window.matchMedia("(min-width: 800px)").matches) {
		return;
	}else{
		init();
	}
	

	
}